import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { fetchSimoSubLeases } from 'actions/simoLeases';
import { simoSubPage } from 'decorators/subPage';
import { getSimoSubLeases, getPageCount } from 'reducers';
import SubLeases from './SubLeases';

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    leases: getSimoSubLeases(state, page),
    pageCount: getPageCount(state, 'simoLeases', `fetchBySub`, page),
    page,
    pageUrl: (subId, pageNum) =>
      `/simo/subscriptions/${subId}/leases?page=${pageNum}`,
  };
};

const mapDispatchToProps = {
  fetchSubLeases: fetchSimoSubLeases,
};

export default compose(
  withRouter,
  simoSubPage,
  connect(mapStateToProps, mapDispatchToProps),
)(SubLeases);
